import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import { EntityOffer } from '../../../../../new-lib/types/entity';
import WhatsappButton from './WhatsappButton';
import GetOfferButton from './GetOfferButton';

interface ButtonContinerProps {
  entity: any;
  offer: EntityOffer;
}

const OfferButtonContainer = ({ entity, offer }: ButtonContinerProps) => {
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseOver = () => setIsHovering(true);
  const handleMouseOut = () => setIsHovering(false);

  const { t } = useTranslation('entity');

  return (
    <ButtonContainer onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      <div className={isHovering ? 'show' : 'hide'}>
        <div className="info-text">
          <p className="get-offer-text">{t('get_offer')}</p>
          <p className="know-more-text">{`${t('know_more')}`}</p>
        </div>
        <WhatsappButton entity={entity} offer={offer} />
      </div>

      <div className={isHovering ? 'hide' : ''}>
        <GetOfferButton />
      </div>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  width: 260px;
  display: flex;
  align-items: start;
  justify-content: center;
  transition: ease-out 3ms;

  .hide {
    display: none;
  }

  .show {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .info-text {
      display: flex;
      flex-direction: column;
      align-items: start;
      text-align: start;
      justify-content: space-between;
      height: 70%;
      color: #666666;

      .get-offer-text {
        font-family: materialBold;
        font-size: 14px;
        text-transform: uppercase;
      }

      .know-more-text {
        font-family: materialRegular;
        font-size: 10px;
      }
    }
  }
`;

export default OfferButtonContainer;
